import { Injectable } from '@angular/core';
import { environment as env } from '../../../environments/environment';
import { IUserInfoCognito } from './cognito.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { SessionService } from './session.service';
import { IServicio, IServicioRaw, IServiciosResponse } from 'src/app/models/monitoreo-servicios/monitoreo-servicios.model';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class MonitoreoServiciosService {
    private endpoint: string = env.backend.notificacionesWebClientes.url;

  	constructor(private http: HttpClient, private _sessionService: SessionService) {}

	private getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
		const headers = new HttpHeaders()
			.set("IDOrganizacion", idOrganizacion)
			.set("IDUsuario", idUsuario)
			.set("requestOrigin", requestOrigin)

		return headers
	}

	private mapServicio(servicioRaw: IServicioRaw): IServicio {
		return {
			id: servicioRaw.servicio.id,
			nombre: servicioRaw.servicio.nombre,
			estado: servicioRaw.estado,
			fecha: servicioRaw.fecha,
			mensaje: servicioRaw.mensaje
		};
	}

	listServices(): Observable<IServicio[]> {
		const userInfo: IUserInfoCognito = this._sessionService.getUserInfo()
		const idUsuario = userInfo.email;
		const idOrganizacion = this._sessionService.getOrganization();

		const headers = this.getHeaders(idOrganizacion, idUsuario, 'WEB');

		return this.http.get<IServiciosResponse>(`${this.endpoint}servicios`, { headers }).pipe(
			map(res => res.servicios.map(servicioRaw => this.mapServicio(servicioRaw)))
		)
	}
}
